<div *ngIf="currentUser$ | async as currentUser" class="username">
    Hola {{ currentUser.username }}
</div>